// extracted by mini-css-extract-plugin
export default {"footerContainer":"@gscope-mfe-common-components__src-components-Footer-___Footer-module__footerContainer___b0D3d"};